export default {
  columns: {
    strategy: 'Strategia',
    source: 'Lähde',
    async: 'Async',
    content: 'Sisältö',
    edit: 'Muokkaa',
    delete: 'Poista',
  },
  buttons: {
    add_script: 'Lisää skripti',
  },
};
